import firebase from "firebase/compat/app";
import "firebase/compat/database";

export const RESEND_COOLDOWN_DEFAULT_SECONDS = 60;

const RESEND_COOLDOWN_MIN_SECONDS = 30;
const RESEND_COOLDOWN_MAX_SECONDS = 600;
const CACHE_TTL_MS = 30_000;

let cachedResendCooldownSeconds: number | null = null;
let cachedWebOtpEnabled: boolean | null = null;
let cacheLoadedAt = 0;

function readFirebaseBool(value: unknown): boolean {
  return value === true || value === 1 || value === "true" || value === "1";
}

function clampResendCooldownSeconds(value: unknown): number {
  let raw: number | null = null;
  if (typeof value === "number" && Number.isFinite(value)) {
    raw = Math.trunc(value);
  } else if (typeof value === "string") {
    const parsed = parseInt(value.trim(), 10);
    if (!Number.isNaN(parsed)) {
      raw = parsed;
    }
  }
  if (raw == null) {
    return RESEND_COOLDOWN_DEFAULT_SECONDS;
  }
  return Math.min(RESEND_COOLDOWN_MAX_SECONDS, Math.max(RESEND_COOLDOWN_MIN_SECONDS, raw));
}

export async function loadResendCooldownSeconds(): Promise<number> {
  const now = Date.now();
  if (cachedResendCooldownSeconds != null && now - cacheLoadedAt < CACHE_TTL_MS) {
    return cachedResendCooldownSeconds;
  }
  if (typeof firebase.database !== "function") {
    return cachedResendCooldownSeconds ?? RESEND_COOLDOWN_DEFAULT_SECONDS;
  }
  try {
    const snap = await firebase
      .database()
      .ref("global/config/2fa/resendCooldownSeconds")
      .once("value");
    const seconds = clampResendCooldownSeconds(snap.val());
    cachedResendCooldownSeconds = seconds;
    cacheLoadedAt = now;
    return seconds;
  } catch {
    return cachedResendCooldownSeconds ?? RESEND_COOLDOWN_DEFAULT_SECONDS;
  }
}

export async function isWebOtpEnabled(): Promise<boolean> {
  const now = Date.now();
  if (cachedWebOtpEnabled != null && now - cacheLoadedAt < CACHE_TTL_MS) {
    return cachedWebOtpEnabled;
  }
  if (typeof firebase.database !== "function") {
    return cachedWebOtpEnabled ?? false;
  }
  try {
    const snap = await firebase
      .database()
      .ref("global/config/2fa/webEnabled")
      .once("value");
    const enabled = readFirebaseBool(snap.val());
    cachedWebOtpEnabled = enabled;
    cacheLoadedAt = now;
    return enabled;
  } catch {
    return cachedWebOtpEnabled ?? false;
  }
}
